import React from "react";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button } from "components/common/Button";
interface NotificationHeaderProps {
  currentView: "notifications" | "settings";
  onOpenSettings: () => void | Promise<void>;
  onBackToNotifications: () => void;
}

export const NotificationHeader: React.FC<NotificationHeaderProps> = ({
  currentView,
  onOpenSettings,
  onBackToNotifications,
}) => {
  return (
    <div className="flex justify-between items-center mb-3">
      {currentView === "notifications" ? (
        <>
          <div></div>
          <Button
            variant="default"
            size="md"
            onClick={(e) => {
              e.stopPropagation();
              onOpenSettings();
            }}
          >
            <SettingsOutlinedIcon />
          </Button>
        </>
      ) : (
        <>
          <Button variant="default" size="sm" onClick={onBackToNotifications}>
            <ArrowBackIcon />
          </Button>
          <h3 className="ml-1 text-fg-semibold flex-1">Preferences</h3>
          <div className="w-8"></div>
        </>
      )}
    </div>
  );
};
